import { DocFlowMappingType } from './DocFlow.constants'
import { DocFlowAccurancy } from './DocFlowMappingWidgets'
import { DOC_FLOW_UPLOADING_DEFAULT_TYPE } from './DocFlowUploading'

export function isDocFlowSplittingType(value) {
  return value === DocFlowMappingType.Splitting
}

export function getDocFlowMappingTypeOptions(t) {
  return [
    {
      label: t('DocumentStapling.MappingPhaseTypeMultiplyingTitleKey'),
      value: DocFlowMappingType.Multiplying,
    },
    {
      label: t('DocumentStapling.MappingPhaseTypeSplittingTitleKey'),
      value: DocFlowMappingType.Splitting,
    },
  ]
}

export function getDocFlowDefaultMappingType(t) {
  return getDocFlowMappingTypeOptions(t).find(isDocFlowSplittingType)
}

export function getDocFlowMappingTypeByValue(value, t) {
  const currentValue = value ?? DOC_FLOW_UPLOADING_DEFAULT_TYPE

  return getDocFlowMappingTypeOptions(t).find(
    item => item.value === currentValue
  )
}

export function getSelectedAreaAccuracyOptions(t) {
  return [
    {
      label: t('DocumentStapling.SplittingWidgetAccuracyHighestLabelKey'),
      value: DocFlowAccurancy.Highest,
    },
    {
      label: t('DocumentStapling.SplittingWidgetAccuracyHighLabelKey'),
      value: DocFlowAccurancy.High,
    },
    {
      label: t('DocumentStapling.SplittingWidgetAccuracyMiddleLabelKey'),
      value: DocFlowAccurancy.Middle,
    },
    {
      label: t('DocumentStapling.SplittingWidgetAccuracyLowLabelKey'),
      value: DocFlowAccurancy.Low,
    },
  ]
}

export function getDocFlowSelectedAreaAccuracyInitialValue(value, t) {
  return getSelectedAreaAccuracyOptions(t).find(
    option => option.value === value
  )
}
